/**
 * Shim — real implementation lives in @vestra/agent-sdk.
 * @see packages/agent-sdk/src/contract/instruction-stack.ts
 */
export type {
  InstructionLayerId,
  InstructionLayer,
  LayerHashes,
  LayerDrift,
  InstructionSnapshot,
  TieredSystemPrompt,
} from '@vestra/agent-sdk';
export {
  NATIVE_PERSISTENCE_INSTRUCTION,
  INSTRUCTION_LAYER_ORDER,
  SESSION_FROZEN_LAYER_IDS,
  FLEET_STATIC_LAYER_IDS,
  assembleInstructionStack,
  splitInstructionStack,
  hashStaticLayers,
  assertLayerHashes,
  hashSessionFrozenLayers,
  assertSessionFrozenLayerHashes,
  describeInstructionStack,
} from '@vestra/agent-sdk';
